// extracted by mini-css-extract-plugin
export default {"panel":"ActionsPanel_panel__XtAM6","actions":"ActionsPanel_actions__DNi89","links":"ActionsPanel_links__OHlr1"};